import { ControlMarkAsOptions } from '../models/control-mark-as-options';

export const DEFAULT_MARK_AS_OPTION: ControlMarkAsOptions = {
  emitEvent: true,
  onlySelf: false
};
